import React, { useState } from "react";
import { notification } from "../../utils/Notifications.tsx";
import { deletePermissionFile } from "../../services/permissions.service.ts";

const PermissionFormEditFiles = ({ permission, reloadFiles, isDisabled = false }) => {
  const [loading, setLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const handleDelete = async (fileId) => {
    if (isDisabled) {
      notification("Info", "No se pueden eliminar archivos de un permiso procesado", "info");
      return;
    }

    setLoading(true);
    try {
      await deletePermissionFile(fileId);
      notification("Éxito", "Archivo eliminado correctamente", "success");
      setLoading(false);
      reloadFiles();
    } catch (error) {
      console.error("Error al eliminar el archivo:", error);
      notification("Error", "No se pudo eliminar el archivo", "danger");
      setLoading(false);
    }
  };

  const handleExistingImageClick = (file) => {
    if (file.permissionFile.extension.match(/(png|jpg|jpeg)$/)) {
      setPreviewImage(file.permissionFile.url);
    }
  };

  const closePreview = () => {
    setPreviewImage(null);
  };

  if (!permission || !permission.permissionFiles || permission.permissionFiles.length === 0) {
    return (
      <div className="row p-4">
        <div className="col-12">
          <p className="text-muted">No hay archivos adjuntos para este permiso.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="row p-4">
      <div className="col-12 mb-4">
        <h6>Archivos adjuntos:</h6>
        {/* {isDisabled && (
          <div className="alert alert-warning mb-3">
            <i className="fas fa-exclamation-triangle me-2"></i>
            Los archivos no se pueden eliminar de un permiso procesado.
          </div>
        )} */}
        <div className="row">
          {permission.permissionFiles.map((file) => (
            <div key={file.id} className="col-md-3 mb-3">
              <div
                className="card shadow-sm border-light rounded position-relative"
                style={{ transition: "transform 0.2s", cursor: "pointer" }}
                onClick={() => handleExistingImageClick(file)}
              >
                <div className="card-body text-center">
                  <div className="mb-3">
                    {file.permissionFile.extension.match(/(png|jpg|jpeg)$/) ? (
                      <img
                        src={file.permissionFile.url}
                        alt={file.permissionFile.name}
                        className="img-fluid rounded"
                        style={{
                          maxHeight: "150px",
                          objectFit: "cover",
                        }}
                      />
                    ) : file.permissionFile.extension.match(/(pdf)$/) ? (
                      <div>
                        <p>Archivo PDF, haz clic en "Ver".</p>
                        <a
                          href={file.permissionFile.url}
                          className="btn btn-secondary"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Ver PDF
                        </a>
                      </div>
                    ) : (
                      <p>Vista previa no disponible</p>
                    )}
                  </div>
                  {/* {!isDisabled && (
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDelete(file.id);
                      }}
                      title="Eliminar"
                      disabled={loading}
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  )} */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {previewImage && (
        <div
          className="modal fade show d-block bg-black bg-opacity-75"
          tabIndex="-1"
          onClick={closePreview}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img
                  src={previewImage}
                  alt="Vista previa"
                  className="img-fluid"
                  style={{ maxHeight: "90vh", objectFit: "contain" }}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-danger" onClick={closePreview}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PermissionFormEditFiles; 